"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDrinkCardOrderPage = getDrinkCardOrderPage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 畅饮卡/购买记录分页
 * 新地址：xyUserAccountBonus/orderPage（购买记录控制器）
 * 默认 type=13 畅饮卡
 */
function getDrinkCardOrderPage(params) {
  return (0, _requestAuth.default)({
    url: '/xyUserAccountBonus/orderPage',
    method: 'get',
    params: params
  });
}